import React from "react";
import {schemaMatches} from "@jsonforms/core";
import {withJsonFormsControlProps} from "@jsonforms/react";
import I18nAutocomplete from "../../i18n-autocomplete";
import {RENDERER_TYPES} from "../constants";
import {pruneEmptyValues} from "../utils";

export const I18nAutocompleteTester = schemaMatches(schema => schema.renderer === RENDERER_TYPES.i18nAutocomplete);

export const I18nAutocompleteRenderer = withJsonFormsControlProps(
  ({data, handleChange, path, label, schema, required, errors}) => {
    const options = schema?.elements || [];
    return (
      <I18nAutocomplete
        multiple
        freeSolo={options.length === 0}
        options={options}
        value={data}
        onChange={value => handleChange(path, pruneEmptyValues(value))}
        renderInputProps={{
          fullWidth: true,
          variant: "outlined",
          label: label,
          required: required,
          error: !!errors,
          helperText: errors
        }}
        className="custom-json-forms__renderers__i18n-autocomplete"
      />
    );
  }
);
